var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrvIconsvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "46px",
    viewBox: "0 0 24 46",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0743 45.0635L0.584304 24.5613C-0.194768 23.6983 -0.194768 22.304 0.584304 21.4387L19.0743 0.936454C20.1989 -0.312151 22.0287 -0.312151 23.1554 0.936454C24.2801 2.18506 24.2801 4.21152 23.1554 5.46012L7.33825 23.0011L23.1554 40.5376C24.2801 41.7885 24.2801 43.8149 23.1554 45.0635C22.0287 46.3121 20.1989 46.3121 19.0743 45.0635",
    id: "Chevron-Copy-3",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrvIconsvg);
export default __webpack_public_path__ + "static/media/PrvIconsvg.a666d567.svg";
export { ForwardRef as ReactComponent };